<style>

</style>

<template>
  <div class="header">
    <div class="header_box">
      <div class="search_box">
        <input type="text" maxlength="20" class="seachIpt"  @click="toSearch" :placeholder="keyword">
        <img src="./../assets/images/search.png" class="search_img" @click="toSearch" />
      </div>
      <div class="m_clearLR navbar_box">
        <div class="m_floatL "  :class="activeIndex==index?'active':''" v-for="(item,index) in textArr" :key="item" @click="tabClick(index)">{{item}}</div>
      </div>
    </div>

  </div>
</template>

<script>
import {getKeywords} from '@/api/api'
export default {
  data () {
    return {
      activeIndex: 0,
      textArr: ['软件下载', '使用教程', '故障排查'],
      testHref: ['/', '/tutorialDown', '/troubleshooting'],
      keyword: ''
    }
  },
  created () {
    getKeywords().then((res) => {
      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].use) {
          this.keyword = res.data[i].keywordsId[0].value
          localStorage.setItem('searchWord', this.keyword)
          break
        }
      }
    })
    for (var i = 0; i < this.testHref.length; i++) {
      if (this.testHref[i] == this.$route.path) {
        this.activeIndex = i
      }
    }
  },
  methods: {
    toSearch () {
      this.$router.push({path: '/searching'})
    },
    tabClick (index) {
      this.$emit('')
      this.activeIndex = index
      this.$router.push({path: this.testHref[index]})
    }
  },
  watch: {
    // 控制购物车显示/隐藏，当是购物车页面时隐藏
    '$route.path': function (a, b) {
      for (var i = 0; i < this.testHref.length; i++) {
        if (this.testHref[i] == a) {
          this.activeIndex = i
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/header.vue